import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogContent,
    IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import {
    proposalBasicInfo,
    proposalStatusInfo,
    proposalDetailsInfo,

} from "../../proposals/components/Proposals/config";

import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { RenderFields } from "./RenderFields";
import CustomerAccordion from '../../setup/components/Customer/accordion/CustomerAccordion';
import WorkPhaseModal from '../../proposals/components/WorkPhase/WorkPhaseModal';
import ConfirmationPopup from './ConfirmationPopUp';
import { downloadProposalPdf } from '../../proposals/components/Proposals/useProposalsFormLogic';
import API_BASE_URL from '../../../Constants';
import { ColorRing } from 'react-loader-spinner';




const ViewProposal = ({ open, handleClose, proposal, setProposal, setNext, setPrev, allProposals, updateAll, }) => {

    const [isFullView, setIsFullView] = useState(false);
    const [proposalData, setProposalData] = useState(proposal || {});
    const [isPhaseModalOpen, setIsPhaseModalOpen] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [confirmationData, setConfirmationData] = useState({ isApproved: false });
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        setProposalData(proposal || {});
    }, [proposal]);



    const openConfirmation = (isApproved) => {
        setConfirmationData({ isApproved });
        setIsConfirmationOpen(true);
    };

    const handleUpdateProposalStatus = async (userName) => {
        setIsConfirmationOpen(false);
        setIsLoading(true);
        let updatedProposal = { ...proposalData };
        const isApproved = confirmationData.isApproved;

        if (isApproved) {
            updatedProposal = { ...updatedProposal, proposalStatus: "Accepted", approvedBy: userName, approvalDate: new Date().toISOString() };
        } else {
            updatedProposal = { ...updatedProposal, proposalStatus: "Proposal Rejected", cancelledBy: userName, cancellationDate: new Date().toISOString() };
        }

        const response = await fetch(`${API_BASE_URL}/api/approver/${proposal.proposalNumber}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedProposal),
            credentials: "include",
        });

        if (response.ok) {
            const data = await response.json();
            setProposal(data);
            updateProposals(data);
            alert(isApproved ? "Proposal Approved Successfully" : "Proposal Rejected Successfully");


        } else {
            alert("Error updating proposal status");
        }

        setIsLoading(false);
    };





    const updateProposals = (proposal, isDelete = false) => {
        let all = [...allProposals]
        let index = all.findIndex((c) => String(c.proposalNumber) === String(proposal.proposalNumber));
        if (isDelete) {
            all.splice(index, 1);
        } else {
            all[index] = proposal;
        }
        updateAll(all);

    }

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setProposalData((prevData) => ({ ...prevData, [name]: value }));
    };




    const splitFields = (fieldsArray) => {
        const midIndex = Math.ceil(fieldsArray.length / 2);
        return [fieldsArray.slice(0, midIndex), fieldsArray.slice(midIndex)];
    };




    if (!proposal) return null

    return (
        <>
            {/* Previous and Next Buttons placed outside the modal */}
            {open && (
                <IconButton
                    onClick={setPrev}
                    sx={{
                        position: 'fixed',
                        left: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#ffffff',
                        border: '1px solid #ccc',
                        zIndex: 1301, // Higher than the modal's z-index
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                    }}
                    aria-label="Previous Customer"
                >
                    <NavigateBeforeIcon />
                </IconButton>
            )}

            {open && (
                <IconButton
                    onClick={setNext}
                    sx={{
                        position: 'fixed',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#ffffff',
                        border: '1px solid #ccc',
                        zIndex: 1301,
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                        },
                    }}
                    aria-label="Next Customer"
                >
                    <NavigateNextIcon />
                </IconButton>
            )}

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="xl"
                fullWidth={true}
                fullScreen={isFullView}
                PaperProps={{
                    sx: {
                        backgroundColor: 'white',
                        boxShadow: 'none',
                        margin: isFullView ? 2 : 'auto',
                        width: isFullView ? 'calc(100% - 32px)' : '80%',
                        height: isFullView ? 'calc(100% - 32px)' : '80%',
                        marginTop: isFullView ? '12%' : '8%'
                    },
                }}
            >

                {/* Header */}
                <div className="sticky top-0 bg-white z-10">
                    <div className="flex justify-between items-center p-4">
                        {/* Left section: Back button and title */}
                        <div className="flex items-center space-x-4 flex-grow">
                            <button
                                onClick={handleClose}
                                className="p-2 rounded-full hover:bg-gray-200 transition"
                                aria-label="Back"
                            >
                                <ArrowBackIcon />
                            </button>
                            <h2 className="text-2xl font-bold text-left">
                                {`View Proposal`} - {proposalData.proposalNumber}
                            </h2>
                        </div>
                        {/* Right section: Expand/Shrink Button */}
                        <button
                            onClick={() => setIsFullView(!isFullView)}
                            className="p-2 rounded-full hover:bg-gray-200 transition"
                            aria-label={isFullView ? 'Shrink Modal' : 'Expand Modal'}
                        >
                            {isFullView ? <FullscreenExitIcon /> : <FullscreenIcon />}
                        </button>
                    </div>
                    <div className="flex space-x-4 p-4">

                        <button
                            className="px-6 py-2 bg-blue-600 text-white font-bold rounded-md hover:bg-blue-700 transition"
                            onClick={() => setIsPhaseModalOpen(true)}
                        >
                            View Work Phases
                        </button>


                        <button
                            onClick={() => downloadProposalPdf(proposalData.proposalNumber, setIsLoading)}
                            className="px-6 py-2 bg-blue-600 text-white font-bold rounded-md hover:bg-blue-700 transition"
                        >
                            Export PDF
                        </button>

                        {!isLoading && !isConfirmationOpen && <>
                            {!["Accepted", "Proposal Rejected"].includes(proposalData.proposalStatus) ? (
                                <>
                                    <button
                                        onClick={() => openConfirmation(true)}
                                        className="px-6 py-2 bg-green-500 text-white font-bold rounded-md hover:bg-green-600 transition"
                                    >
                                        Approve
                                    </button>


                                    <button

                                        onClick={() => openConfirmation(false)}
                                        className="px-6 py-2 bg-red-500 text-white font-bold rounded-md hover:bg-red-600 transition"
                                    >
                                        Reject
                                    </button>
                                </>
                            )
                                :
                                (
                                    <p className="px-6 py-2 bg-yellow-500 text-white font-bold rounded-md hover:bg-yellow-600 transition">
                                        Proposal status can no longer be changed!
                                    </p>
                                )
                            }
                        </>}

                    </div>
                </div>

                {isLoading ? (
                    <div className="flex justify-center items-center h-full">
                        <ColorRing color="#247399" />
                    </div>
                ) : (
                    <DialogContent
                        dividers
                        sx={{
                            padding: 0,
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                        }}>

                        {/* Basic Info Accordion */}
                        {(() => {
                            const [generalInfoLeft, generalInfoRight] = splitFields(
                                proposalBasicInfo
                            );
                            return (
                                <CustomerAccordion label="General Info">
                                    <div
                                        className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                            } gap-4`}
                                    >
                                        <div className="w-full">
                                            <RenderFields
                                                fields={generalInfoLeft}
                                                formData={proposalData}
                                                handleChange={handleFieldChange}
                                                readOnly={true}

                                            />
                                        </div>
                                        <div className="w-full">
                                            <RenderFields
                                                fields={generalInfoRight}
                                                formData={proposalData}
                                                handleChange={handleFieldChange}
                                                readOnly={true}


                                            />
                                        </div>
                                    </div>

                                    <div
                                        className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                            } gap-4`}
                                    >

                                        <div className='flex flex-row w-2/3'>
                                            <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                Building Reference
                                            </label>
                                            <span
                                                className={`h-10 border border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                style={{ minWidth: '200px' }}
                                            >
                                                {proposalData?.building?.buildingReference || 'N/A'}- {proposalData?.building?.buildingNote || 'N/A'}
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                            } gap-4`}
                                    >

                                        <div className='flex flex-row w-2/3'>
                                            <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                Sales Rep
                                            </label>
                                            <span
                                                className={`h-10 border  border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                style={{ minWidth: '200px' }}
                                            >
                                                {proposalData?.salesPerson?.firstName} {proposalData?.salesPerson?.lastName}
                                            </span>
                                        </div>
                                    </div>
                                    <div className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'} gap-4`}>
                                        <div className='flex flex-row w-2/3'>
                                            <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                Contact
                                            </label>
                                            <span
                                                className={`h-10 border  border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                style={{ minWidth: '200px' }}>
                                                {proposalData?.contact?.contactName} - {proposalData?.contact?.cellPhone}
                                            </span>
                                        </div>
                                    </div>
                                </CustomerAccordion>
                            );
                        })()}


                        {/* Status Info Accordion */}
                        {(() => {
                            const [generalInfoLeft, generalInfoRight] = splitFields(
                                proposalStatusInfo
                            );
                            return (
                                <CustomerAccordion label="Status Info">

                                    <div
                                        className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                            } gap-4`}
                                    >
                                        <div key={"Proposal Class"} className="flex flex-col w-full">
                                            <div className="flex justify-between items-center w-full pb-2">


                                                <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                    Proposal Class
                                                </label>
                                                <span
                                                    className={`h-10 border border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                    style={{ minWidth: '200px' }}>
                                                    {proposalData?.proposalSubClass?.proposalClass?.className || 'N/A'}
                                                </span>
                                            </div>

                                        </div>

                                        <div key={"proposalSubClass"} className="flex flex-col w-full">
                                            <div className="flex justify-between items-center w-full pb-2">
                                                <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300">
                                                    Proposal SubClass
                                                </label>
                                                <span
                                                    className={`h-10 border border-gray-300 flex-grow px-4 bg-gray-100 flex items-center`}
                                                    style={{ minWidth: '200px' }}>
                                                    {proposalData?.proposalSubClass?.subClassName || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'} gap-4`}>
                                        <div className="w-full">
                                            <RenderFields
                                                fields={generalInfoLeft}
                                                formData={proposalData}
                                                handleChange={handleFieldChange}
                                                readOnly={true}
                                            />
                                        </div>
                                        <div className="w-full">
                                            <RenderFields
                                                fields={generalInfoRight}
                                                formData={proposalData}
                                                handleChange={handleFieldChange}
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </CustomerAccordion>
                            );
                        })()}

                        {/* Details Accordion */}
                        {(() => {
                            const [generalInfoLeft, generalInfoRight] = splitFields(
                                proposalDetailsInfo
                            );
                            return (
                                <CustomerAccordion label="Proposals Details Info">
                                    <div
                                        className={`flex ${isFullView ? 'flex-row' : 'flex-col md:flex-row'
                                            } gap-4`}
                                    >
                                        <div className="w-full">
                                            <RenderFields
                                                fields={generalInfoLeft}
                                                formData={proposalData}
                                                handleChange={handleFieldChange}
                                                readOnly={true}

                                            />
                                        </div>
                                        <div className="w-full">
                                            <RenderFields
                                                fields={generalInfoRight}
                                                formData={proposalData}
                                                handleChange={handleFieldChange}
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </CustomerAccordion>
                            );
                        })()}

                    </DialogContent>)}





            </Dialog >

            <ConfirmationPopup
                open={isConfirmationOpen}
                onClose={() => setIsConfirmationOpen(false)}
                onConfirm={handleUpdateProposalStatus}
                message={confirmationData.isApproved ? "Are you sure you want to approve this proposal?" : "Are you sure you want to reject this proposal?"}
                placeholder={confirmationData.isApproved ? "Enter Approver Name" : "Enter Rejecter Name"}
            />

            <WorkPhaseModal
                open={isPhaseModalOpen}
                handleClose={() => setIsPhaseModalOpen(false)}
                proposalNumber={proposal?.proposalNumber}
                buildingId={proposal?.building?.buildingId || proposal?.building?.buildingID}
                viewOnly={true}
            />

        </>
    );
};

export default ViewProposal;
